export default function copyIdToClipboard(contentId) {
    const tempElement = document.createElement('textarea');
    tempElement.value = contentId;
    document.body.appendChild(tempElement);
    tempElement.select();
    document.execCommand('copy');
    document.body.removeChild(tempElement);
}
